import { format } from 'date-fns';

/**
 * Formats the reserve-window "squares open at" timestamp (DKPLAT-529).
 * Returns null when there is no reserve window, so callers can skip the line.
 */
export const formatSquaresAvailableAt = (
  questionsPostedAt: string | null | undefined
): string | null =>
  questionsPostedAt ? format(new Date(questionsPostedAt), 'EEEE, MMM d, h:mm a') : null;
